/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-01T17:22:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-06T12:42:43-07:00
*/



import React, { Component } from 'react';
import TripCard from './TripCard';
import BlankSlate from '../../blocks/BlankSlate';
import ResultList from '../../blocks/ResultList';
import Button from '../../blocks/Button';
import { Link } from 'react-router';
import _ from 'lodash';
import { css, StyleSheet } from 'aphrodite/no-important';
import { box, dimensions, spacing } from '../../../style';

const style = StyleSheet.create({
  list: {
    ...spacing.PADDING_0,

    [dimensions.SCREEN_MIN_MD]: {
      ...box
    }
  }

});

let tripCreateMessage = () => {
  return (
    <div>
    <div style={{...dimensions.MARGIN_BOTTOM_SM}}>Other members can search for and ask to join trips you create.</div>
    <div style={{marginTop: 22}}><Button to="/trip/create" variant='primary'>Create a trip</Button></div>
    </div>

  )
}

class TripsList extends Component {

  constructor(props) {
    super(props);
    this.tripList = this.tripList.bind(this);
  }

  tripList(trips) {
    if(!_.isEmpty(trips)) {
      var TripList = Object.keys(trips).map((key) => {
        return <TripCard key={key} tripKey={key} cancelTrip={this.props.cancelTrip} data={trips[key]} />;
      });
      return TripList;
    }
    else {
      return <BlankSlate title="Create a trip for people to see" message={tripCreateMessage()}></BlankSlate>;
    }
  }

  render() {
    return (
      <ResultList>
        {this.tripList(this.props.trips)}
      </ResultList>

    );
  }
}

export default TripsList;



// WEBPACK FOOTER //
// ./src/components/pages/Trips/TripsList.jsx